import { render, staticRenderFns } from "./CopyStakeAutoclickerTab.vue?vue&type=template&id=033c5aa0&scoped=true&lang=pug"
import script from "./CopyStakeAutoclickerTab.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAutoclickerTab.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAutoclickerTab.vue?vue&type=style&index=0&id=033c5aa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c5aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VChip,VCol,VDataTable,VIcon,VRow,VSwitch})
